<template>
  <div>
    <shared-outbound-select-members @selectMember="selectMember" :members="members"></shared-outbound-select-members>
  </div>
</template>

<script>
import SharedOutboundSelectMembers from '@/views/Shared/Consultations/SelectMembers'
import Utils from '@/helpers/utils'

import Member from '@/models/Member'

export default {
  name: 'Window.Consultation.SelectMembers',
  components: {
    SharedOutboundSelectMembers
  },
  data () {
    return {
      members: {},
      callback_id: 0,
      phone_number: ''
    }
  },
  mounted () {

    this.callback_id = this.$route.query.callback_id
    this.phone_number = this.$route.query.phone_number

    this.$windowOpenerHelper.listenToPopUpMessage('reload_consultation_callback_member_table', this.loadCallbackData)
    this.loadMembers()

  },
  methods: {
    async loadMembers () {
      const response = await Member.getMembers(this.phone_number)
      this.members = response.data.members
    },
    loadCallbackData () {
      this.$windowOpenerHelper.notifyOpener('reload_consultation_callback_member_table')
      window.close()
    },
    selectMember (memberId) {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'outbound', { id: memberId, callback_id: this.callback_id })
    }
  }
}
</script>

<style scoped>

</style>
